import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import ListItemText from "@mui/material/ListItemText";
import ListItemButton from "@mui/material/ListItemButton";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import Slide from "@mui/material/Slide";
import DynamicForm from "../InputFields";
import StepperForm from "./StepperBox";
import { useSelector } from "react-redux";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function DialogBox({
  activeTab,
  open,
  handleCloseDialog,
  data,
}) {
  const {
    headerDataForParticular,
    bodyDataForParticular,
    footerDataForParticular,
  } = useSelector((state) => state?.aiDataReducer);

  return (
    <Dialog
      fullScreen
      open={open}
      onClose={handleCloseDialog}
      TransitionComponent={Transition}
    >
      <AppBar sx={{ position: "relative" }}>
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            onClick={handleCloseDialog}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
          <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
            {headerDataForParticular &&
            bodyDataForParticular &&
            footerDataForParticular
              ? "Update Data"
              : activeTab}
          </Typography>
        </Toolbar>
      </AppBar>
      <List>
        {activeTab === "Assign Campaign" && (
          <DynamicForm data={data} activeTab={activeTab} />
        )}
        {activeTab === "Structure Creator" && (
          <StepperForm
            activeTab={activeTab}
            handleCloseDialog={handleCloseDialog}
          />
        )}
      </List>
    </Dialog>
  );
}
